import { AfterViewInit, Directive, ElementRef, inject, Input } from '@angular/core';
import { KeyboardSearchDirective } from '../keyboard-search/keyboard-search.directive';

@Directive({
	selector: '[evasysKeyboardSearchElement]',
})
export class KeyboardSearchElementDirective implements AfterViewInit {
	@Input('evasysKeyboardSearchElement')
	text?: string;

	private _elementRef = inject(ElementRef);
	private readonly keyboardSearchDirective = inject(KeyboardSearchDirective);
	private isRegistered = false;

	ngAfterViewInit() {
		this.register();
	}

	private register() {
		if (!this.isRegistered) {
			if (this._elementRef?.nativeElement?.textContent) {
				this.isRegistered = true;
				this.keyboardSearchDirective?.registerElement(
					this._elementRef,
					this.text?.length > 0 ? this.text : this._elementRef.nativeElement.textContent?.trim()
				);
			}
		}
	}
}
